"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAddressLines = parseAddressLines;
function parseAddressLines(lines, isIAB = false) {
    const [name = '', additionalInfo] = lines ?? [];
    const maxLength = 35;
    return {
        additionalInfo: additionalInfo && additionalInfo.trim().length > 0
            ? additionalInfo.substring(0, maxLength)
            : isIAB && name.length > maxLength
                ? name.substring(maxLength)
                : '',
        name: name.substring(0, maxLength),
    };
}
//# sourceMappingURL=parse-address-lines.js.map